import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { ScrollRegionComponent } from '@brightside/angular-bds';
import { Popover } from 'primeng/popover';
import { ConnectorStateService } from './connector-state.service';

@Component({
  selector: 'lib-connector-status',
  imports: [Popover, ScrollRegionComponent],
  providers: [ConnectorStateService],
  host: {
    '[class.connector-status--compact]': 'compact()',
  },
  templateUrl: './connector-status.component.html',
  styleUrl: './connector-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectorStatusComponent {
  readonly agentIdentifier = input<string | null>();
  readonly compact = input(false);
  readonly state = inject(ConnectorStateService);
  readonly connectorPopover = viewChild<Popover>('connectorPopover');

  constructor() {
    effect(() => this.state.setAgentIdentifier(this.agentIdentifier()));
  }

  toggleDetails(event: Event, anchor: HTMLElement): void {
    this.connectorPopover()?.toggle(event, anchor);
  }

  connect(mcpServerId: string): void {
    void this.state.connect(mcpServerId);
  }

  disconnect(mcpServerId: string): void {
    void this.state.disconnect(mcpServerId);
  }

  refresh(): void {
    void this.state.refreshStatus();
  }
}
